import { AddProgramFormComponent } from './add-program-form';
import { AssignDepartmentToProgramComponent } from './assign-department';
import { AssignProjectToProgramComponent } from './assign-project';

export * from './add-program-form';
export * from './assign-department';
export * from './assign-project';



export const ProgramOrganisms = [
    AddProgramFormComponent,
    AssignDepartmentToProgramComponent,
    AssignProjectToProgramComponent
]